<template>
  <div class="user">
    <div class="" v-loading="loading">
      <div class="s_wrapper">
        <el-input class="s_input" v-model="userCode" placeholder="请输入用户编号" suffix-icon="el-icon-search"
          @change="onSearch" clearable></el-input>
        <el-input class="s_input" v-model="userName" placeholder="请输入用户名称" suffix-icon="el-icon-search"
          @change="onSearch" clearable></el-input>
        <el-select class="s_input" v-model="sourceType" placeholder="请选择行为类型" clearable @change="onSearch">
          <el-option v-for="item in sourceTypeOptions" :key="item.value" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
        <el-select class="s_input" v-model="bizType" placeholder="请选择场景" clearable @change="onSearch">
          <el-option v-for="item in bizTypeOptions" :key="item.value" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
        <!-- <el-date-picker v-model="formInline.time" @change="gettime" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期"
          style="border-radius: 10px;  margin-left: 20px; border: 1px solid #ccc" value-format="yyyy-MM-dd">
        </el-date-picker> -->
      </div>

      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip width="100">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="userCode" label="用户编号">
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="userName" label="用户名称">
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="sourceType" label="行为类型">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.sourceType == 1">观看课程</span> -->
              <span v-if="scope.row.sourceType == 1 || scope.row.sourceType == 3">观看</span>
              <span v-if="scope.row.sourceType == 2">邀请用户</span>
              <!-- <span v-if="scope.row.sourceType == 3">观看直播</span> -->
              <span v-if="scope.row.sourceType == 4">课后问答</span>
              <span v-if="scope.row.sourceType == 5">每日打卡</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="bizType" label="场景">
            <template slot-scope="scope">
              <span v-if="scope.row.bizType == 0">课程</span>
              <span v-if="scope.row.bizType == 1">直播</span>
              <span v-if="scope.row.bizType == 2">全平台</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="points" label="获得积分"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="createdTime" label="获取时间"></el-table-column>
        </el-table>
      </div>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      userCode: "",//用户编号
      userName: "",//用户名称
      bizType: "",//来源
      bizTypeOptions: [
        { value: "0", label: "课程" },
        { value: "1", label: "直播" },
        { value: "2", label: "全平台" },
      ],
      sourceType: "",//行为
      sourceTypeOptions: [
        { value: "1", label: "观看" },
        { value: "2", label: "邀请用户" },
        // { value: "3", label: "观看" },
        { value: "4", label: "课后问答" },
        { value: "5", label: "每日打卡" },
      ],
      startTime: '',//开始时间
      endTime: '',//结束时间
      formInline: {
        time: []
      },//日期区间,
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getRequestList()
  },
  methods: {
    getRequestList() {
      this.loading = true
      this.$axios
        .get(this.$api.pointDetails, {
          params: {
            userId: null,
            userCode: this.userCode || null,//用户编号
            userName: this.userName || null,//用户昵称
            bizType: this.bizType || null,//来源类型：0：课程；1：直播；2：全平台
            sourceType: this.sourceType || null,//类型：1课时观看；2直播邀请；3直播观看；4课后答题；5：每日打卡
            startTime: this.startTime || null,
            endTime: this.endTime || null,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          this.tableData = res.result.list
          this.totalCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 时间区间搜索
    gettime() {
      this.startTime = this.formInline.time ? this.formInline.time[0] || "" : "";
      this.endTime = this.formInline.time ? this.formInline.time[1] || "" : "";
      this.getRequestList()
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getRequestList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getRequestList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getRequestList()
    },
  },
}
</script>

<style scoped lang="scss">
.user {
  .disabled_user_account {
    width: 255px;
    color: #c0c4cc;
    padding: 0 15px;
    border-radius: 10px;
    background-color: #f5f7fa;
    box-sizing: border-box;
    cursor: not-allowed;
  }
}
</style>
